import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";
import {
  updatePseaAssessment,
  updateAgencyPseaAssessment,
} from "common/services/psea-assessments.service";

/**
 * Resolves whether the current user can edit a PSEA assessment and which
 * endpoint to use. A user may hold either the main API update permission
 * (`psea-assessment` controller) or the agency update permission
 * (`agency` controller). The main API takes precedence when both are present.
 */
export const usePseaUpdater = () => {
  const { userProfile } = useProfile();
  const permissions = userProfile?.permissions;

  const canUpdateMain = isAllowed(permissions, [
    { resource: "psea-assessment", action: "update" },
  ]);
  const canUpdateAgency = isAllowed(permissions, [
    { resource: "psea-assessment", action: "update", controller: "agency" },
  ]);

  const canEdit = canUpdateMain || canUpdateAgency;

  const update = canUpdateMain
    ? updatePseaAssessment
    : canUpdateAgency
    ? updateAgencyPseaAssessment
    : null;

  return { canEdit, update };
};
